import styled from 'styled-components';

export const StyledFunctions = styled.div`
    padding: 2rem;
`;
